<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="openModel('flflx')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="flflxList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				:max-height="maxHeight"
			>
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column type="expand" label="收费阶梯" width="80">
					<template slot-scope="scope">
						<el-table :data="scope.row.fljtb" stripe style="padding-left: 50px;" size="mini" :header-cell-style="{ background: '#f4faf4' }">
							<el-table-column label="简述" width="180">
								<template slot-scope="scope">
									{{scope.row.xzqj_k}}-{{scope.row.xzqj_j}}个品种，{{scope.row.jg}}元/吨/方
								</template>
							</el-table-column>
							<el-table-column label="初始值" width="80" align="center">
								<template slot-scope="scope">
									{{scope.row.xzqj_k}}
								</template>
							</el-table-column>
							<el-table-column label="结束值" width="80" align="center">
								<template slot-scope="scope">
									{{scope.row.xzqj_j}}
								</template>
							</el-table-column>
							<el-table-column label="价格" width="80" align="center">
								<template slot-scope="scope">
									{{scope.row.jg}}
								</template>
							</el-table-column>
						</el-table>
					</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">
						创建时间
					</template>
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>

				<el-table-column align="center" width="190">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel('flflx', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh" width="70%">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl === 'flflx'" ref="form" :model="form.flflx" label-width="80px">
					<el-form-item label="名称"><el-input v-model="form.flflx.name" size="mini" style="width: 95%;"></el-input></el-form-item>
				</el-form>
			</div>
			<div class="m-4 d-flex">
				<div>阶梯判断</div>
			</div>
			<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
			<div class="m-4">
				<el-table :data="fljtb" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column align="center" width="80">
						<template slot="header" slot-scope="scope">
							<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
						</template>
						<template slot-scope="scope">
							<el-button type="danger" size="mini" icon="el-icon-delete" @click="scjt"></el-button>
						</template>
					</el-table-column>
					<el-table-column label="简述" align="center">
						<template slot-scope="scope">
							{{scope.row.xzqj_k}}-{{scope.row.xzqj_j}}个品种，{{scope.row.jg}}元/吨/方
						</template>
					</el-table-column>
					<el-table-column label="区间初始值" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.xzqj_k"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="区间初始值" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.xzqj_j"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="单价" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.jg"></el-input-number>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				flflx: {
				}
			},
			fljtb:[],
			createModel: false,
			dialogType: 'flflx',
			preUrl: 'flflx', //api
			dialogId: 0,
			flflxList: [],
			maxHeight: 0,
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.flflxList = e.list;
		},
		openModel(type, item = false) {
			console.log(item)
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'flflx':
					if (!item) {
						this.form.flflx = {
							id: '',
							name: ''
						};
						this.fljtb = []
						this.dialogId = 0;
					} else {
						this.form.flflx = {
							name: item.name
						};
						if(item.fljtb != null){
							this.fljtb = item.fljtb
						}else{
							this.fljtb = []
						}
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.flflx;
			let e = {
				name: f.name,
				cjr: this.user.id,
				fljtb:this.fljtb
			};
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		},
		pustyl() {
			let data = {
				xzqj_k:0,
				xzqj_j:0,
				jg:0,
				id:0
			}
			this.fljtb.push(data)
		},
		scjt(){}
	}
};
</script>

<style></style>
